/**
 * Enquiry form: lightweight client-side validation. Shows the inline
 * "* This field is required" hints; the submission itself is handled in PHP at
 * the top of the page template (validation → CRM webhook → ffs-contacts).
 */
export function initEnquiryForm() {
  const form = document.querySelector('#register form')
  if (!form) return

  form.addEventListener('submit', (event) => {
    let valid = true

    form.querySelectorAll('input[required]').forEach((input) => {
      const error = input.parentElement.querySelector('.field-error')
      const ok = input.type === 'checkbox' ? input.checked : input.value.trim() !== ''
      if (error) error.classList.toggle('hidden', ok)
      if (!ok) valid = false
    })

    if (!valid) event.preventDefault()
  })
}
